// REAVERFIT — Collection Description Dropdown (CLS Optimized)
// Asset non disruptif pour limiter le texte de description - OPTIMISÉ POUR ZÉRO CLS

document.addEventListener("DOMContentLoaded", function() {
  const desc = document.getElementById("collection-description");
  const btn  = document.getElementById("read-more-btn");
  if (!desc || !btn) return;

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const collapsedHeight = lineHeight * 3; // ≈ 3 lignes
  let expanded = false;

  // Vérifie si le texte est assez long pour nécessiter un collapse
  // OPTIMISÉ : mesure en une fois, sans modification de styles pour éviter CLS
  function needsCollapse() {
    // Clone invisible pour mesurer sans affecter le layout principal
    const clone = desc.cloneNode(true);
    clone.style.cssText = `
      position: absolute;
      top: -9999px;
      left: -9999px;
      width: ${desc.offsetWidth}px;
      max-height: none;
      visibility: hidden;
      pointer-events: none;
    `;
    document.body.appendChild(clone);
    const fullHeight = clone.scrollHeight;
    document.body.removeChild(clone);
    
    return fullHeight > collapsedHeight + 10; // marge de 10px
  }

  // Initialisation optimisée - PAS de modification de layout
  if (!needsCollapse()) {
    // Utilise opacity au lieu de display pour éviter CLS
    btn.classList.add('hidden');
    desc.classList.add('is-expanded');
    return;
  }

  // Gestionnaire d'événements optimisé
  function setState(open) {
    expanded = open;
    btn.setAttribute("aria-expanded", open);
    btn.setAttribute('aria-label', open ? 'Afficher moins de texte' : 'Afficher plus de texte');

    // Optimisation CLS : utilise des classes CSS qui animent plutôt que JS
    if (open) {
      desc.classList.add("is-expanding");
      desc.classList.add("is-expanded");
      // Utilise le CSS pour l'animation, pas de style inline
      setTimeout(() => {
        desc.classList.remove("is-expanding");
      }, 350); // Durée de l'animation CSS
    } else {
      desc.classList.add("is-collapsing");
      desc.classList.remove("is-expanded");
      setTimeout(() => {
        desc.classList.remove("is-collapsing");
      }, 350);
    }
  }

  btn.addEventListener("click", function(e) {
    e.preventDefault();
    setState(!expanded);
  });
  
  // Performance : démarre avec le bon état aria
  btn.setAttribute('aria-label', 'Afficher plus de texte');
});
